import type { FaireProductEntity } from "../../entity_types/product";

export const p_4trvjs5w4f: FaireProductEntity = {
  token: "p_4trvjs5w4f",
  type: "product",
  name: "New Adventures Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/2f143caa549012c04ac8dadfba3d98547d77dfdbfa28e7cd0dc684ccf2f67e0e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c8cad887fbbf5ddd49374640242d7607a99c9588f9697ba55b767149b0b643cf.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:15.654Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
